module.exports = __webpack_public_path__ + "static/media/bin.cc927b3c.svg";